const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"realtions":({"add_a_contact":"Tilføj en kontakt"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;